export default {
	currentPage: '第 {page} 页',
	edit: '编辑',
	editValue: '编辑 {value}',
	goToPage: '跳转到 {page}',
	noResults: '0 条记录',
	pageOfTotal: '{page} / {totalPages} 页。 共 {totalRows} 条记录',
	pageOfUnknownTotal: '{page} / ? 页',
	pagination: '分页导航',
	resultRange: '第 {from} 到 {to} 条，共 {total} 条记录',
	sortBy: '根据 {name} 排序',
	filterBy: '根据 {name} 过滤'
};
